import { useForm }  from "react-hook-form";
import '../../styles/LoginForm.css';


export default function LoginForm({onSubmit, responseMessage, messageTone = 'erro'}){
    
    const { register, handleSubmit } = useForm();

    return (
        <div className="flex flex-col gap-[20px] xl:translate-y-[30px] xl:px-[85px] px-[30px] translate-y-[25px] items-center">
            
            <h1 className="xl:text-center xl:text-[1.3rem] xl:leading-10 xl:text-black text-white">Login</h1>

            <div className="xl:omrs-input-group w-[100%] justify-center flex">
                <label className="omrs-input-filled xl:w-[100%] w-[100%] ">
                    <input className='!w-[100%] !text-[1.4rem] py-[5px] px-[6px]' {...register("username", { required: false })} required=""/>
                    <span className="xl:omrs-input-label hidden">Login</span>     
                </label>
            </div>

            <div className="xl:omrs-input-group w-[100%] justify-center flex">
                <label className="omrs-input-filled xl:w-[100%] w-[100%] ">
                    <input className=' !w-[100%] !text-[1.4rem] py-[5px] px-[6px]' type="password" {...register("password", { required: false })} required=""/>
                    <span className="xl:omrs-input-label hidden">Senha</span>
                </label>
            </div>

            <button 
                id="login-btn" 
                type="submit" 
                onClick={handleSubmit(onSubmit)}
                className='w-[100%] [transition:0.3s_ease] text-[1.2rem] text-[white] outline-[none] border-[none] p-[8px] rounded-[4px] cursor-pointer mx-[0] my-[5px] font-saira btn-azul-prof'>
                Entrar
            </button>

            <p
                className={`h-[50px] w-full text-center text-sm font-medium transition-all duration-500 ease-in-out
                ${messageTone === 'sucesso' ? 'text-green-600' : 'text-red-600'}
                ${responseMessage ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}
            >
                {responseMessage && `${responseMessage}`}
            </p>

        </div>
    )
}